module.exports = __webpack_public_path__ + "img/changeTable.eec513ea.svg";